import { render } from "./TimeLeft.vue?vue&type=template&id=64a673ee&scoped=true"
import script from "./TimeLeft.vue?vue&type=script&lang=js"
export * from "./TimeLeft.vue?vue&type=script&lang=js"

import "./TimeLeft.vue?vue&type=style&index=0&id=64a673ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a673ee"]])

export default __exports__